export default __webpack_public_path__ + "static/media/zone-add.664ff290.svg";